import { Form, Input } from 'antd';
import { useContext } from 'react';

import { FieldContext } from '../FieldContext';
import { kennitalaValidatorFinal, kennitalaValidatorOnChange, kennitalaNormalize } from '../utils';
import { useFormatMessage } from '../hooks'

const { Item } = Form

const maxLength = 100 // we need some reasonable limit

const fieldConfigs = {
  createDate: {
    default: true,
  },
  createdByUserName: {
    default: true,
  },
  businessKey: {
    default: true,
  },
  kennitala: {
    normalize: kennitalaNormalize, // TODO: normalize is garbage as cursor position gets reset
    rules: [
      {
        validateTrigger: ['onChange'],
        validator: kennitalaValidatorOnChange,
      },
      {
        validateTrigger: ['onBlur', 'onSubmit'],
        validator: kennitalaValidatorFinal,
      },
    ]
  },
  recipientName: {
  },
  street: {
  },
  senderOrderId: {
  },
  description: {
  },
  currentState: {
    default: true,
  },
  //TODO should be called lockerStatus
  apexStatus: {
    default: true,
  },
  branchName: {
    default: true,
  },
  //these are part of the Registration stuff for boxes. Maybe just skip it
  //used for exchange flow only
  //this one does not have feedback for some reason
  // oldItemDescription: {
  //   rules: [{ type: "string", required: false, whitespace: true }]
  //   //stupid style used when in delivering to shelf. Is it possible to do that on the child instead?
  // },
  // //this is part of the registration stuff for shelves
  // location: {
  //   default: true,
  //   rules: [{ type: "string", required: true, whitespace: true }]
  // },
  // //used for exchange flow only
  // oldLocation: {
  //   rules: [{ type: "string", required: true, whitespace: true }]
  // },
  //locker boxes are currently a bit too complex to think about
  //maybe simplify and then do the complex stuff on the children?
  //finally we have a submit button. Let's not worry about that
  // {
  //   lockerboxThingy: {
  //     rules: ["required"]
  //     //some complex radio group thingy
  //   }
  // },
}

/**
 * Reusable Input Field, with validation, that could be readOnly or disabled.
 * @prop {name} string (required)
 * @prop {disabled} bool (optional)
 * @prop {readOnly} bool (optional)
 */
const InputField = ({ name, disabled = false, readOnly = false }) => {
  const f = useFormatMessage()
  const fields = useContext(FieldContext)

  const fieldUsed = name => fields.get(name)?.used ?? false
  const isRequired = name => fields.get(name)?.required ?? false

  const fieldConfig = fieldConfigs[name]

  if (!(fieldConfig.default || fieldUsed(name))) return null

  const baseRule = {
    type: "string",
    whitespace: true,
    required: isRequired(name)
  }

  const extraRules = (fieldConfig.rules ?? []).map(rule => ({
    ...rule,
    // we get the message from the validator and need to pass in the formatter
    validator: (ruleParam, value) => rule.validator(ruleParam, value, f)
  }))

  const rules = [baseRule].concat(extraRules)

  return (
    <Item
      name={name}
      label={f(`delivery.${name}.label`)}
      valuePropName="value"
      messageVariables={{ msgLabel: f(`delivery.${name}.validationName`) }}
      rules={rules}
      normalize={fieldConfig.normalize}
      validateTrigger={["onBlur", "onSubmit", "onChange"]}
      hasFeedback
    >
      <Input readOnly={readOnly} disabled={disabled} maxLength={maxLength}></Input>
    </Item>
  )
}

export default InputField